import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { OVERLAYS } from '../../constants';
import {
  AnalyticsProvider,
  FetchProvider,
  SocketProvider,
} from '../../providers';
import { overlayReset, getOverlay } from '../../reducers/Overlay/actions';
import { AdVideo, Container, GlobalStyle } from './styles';

function Overlay() {
  let { overlayId } = useParams();
  const overlay = useSelector((state) => state.overlay);
  const { data: overlayData } = overlay;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOverlay(overlayId));
    AnalyticsProvider.hit(`/overlay/${overlayId}`);
    return () => {
      dispatch(overlayReset);
      SocketProvider.disconnect();
    };
  }, [overlayId, dispatch]);

  useEffect(() => {
    let visible = true;
    let recording = false;
    let streaming = false;
    const onSourceVisibleChanged = (event) => {
      visible = event.detail.visible;
    };
    window.addEventListener('obsSourceVisibleChanged', onSourceVisibleChanged);
    const sendTrackEvent = () => {
      AnalyticsProvider.event('TRACK_OVERLAY_TIME', {
        label: overlayId,
        category: overlayData.category,
        key: overlayData.key,
        type: overlayData.type,
        createdAt: overlayData.createdAt,
        obs: !!window.obsstudio,
        streaming,
        recording,
        visible,
      });
    };
    const intervalTrackTime = setInterval(() => {
      if (window.obsstudio) {
        window.obsstudio.getStatus((status) => {
          streaming = status?.streaming;
          recording = status?.recording;
          sendTrackEvent();
        });
      } else {
        sendTrackEvent();
      }
    }, 30000);
    return () => {
      window.removeEventListener(
        'obsSourceVisibleChanged',
        onSourceVisibleChanged
      );
      clearInterval(intervalTrackTime);
    };
  }, [overlayId, overlayData]);

  useEffect(() => {
    const onSourceActiveChanged = (event) => {
      localStorage.setItem(`${overlayId}-active`, event.detail.active);
    };
    const onSourceVisibleChanged = (event) => {
      localStorage.setItem(`${overlayId}-visible`, event.detail.visible);
    };
    window.addEventListener('obsSourceActiveChanged', onSourceActiveChanged);
    window.addEventListener('obsSourceVisibleChanged', onSourceVisibleChanged);

    const intervalTrackBackendTime = setInterval(() => {
      try {
        FetchProvider.fetchPost('track/overlay', {
          active: localStorage.getItem(`${overlayId}-active`),
          overlayId,
          visible: localStorage.getItem(`${overlayId}-visible`),
        });
      } catch (error) {}
    }, 60000);
    return () => {
      window.removeEventListener(
        'obsSourceVisibleChanged',
        onSourceVisibleChanged
      );
      clearInterval(intervalTrackBackendTime);
    };
  }, [overlayId]);

  const OverlayComponent = OVERLAYS.COMPONENTS[overlayData.key];

  if (!OverlayComponent) return <GlobalStyle />;

  return (
    <>
      <GlobalStyle />
      <Container alignment={overlayData?.settings?.alignment}>
        <OverlayComponent data={overlayData.data} styles={overlayData.styles} />
        {overlay?.ad && (
          <AdVideo autoPlay loop muted width="420">
            <source src={overlay?.ad?.gif} type="video/webm" />
          </AdVideo>
        )}
      </Container>
    </>
  );
}

export default Overlay;
